import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';
import Inner from 'components/Inner/Inner';

export const FooterContainer = styled.footer`
    background: ${({ theme }) => theme.background.footer};
    color: ${({ theme }) => theme.color.footer};
    font-size: 14px;
    line-height: 24px;
    margin-top: auto;
    @media only screen and (${Breakpoints.LAPTOP}) {
      margin-bottom: 0;
    }
`;
export const FooterInner = styled(Inner)`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: stretch;
    text-align: center;
    padding: ${({ theme }) => `14px ${theme.paddings.inner.mobile.paddingLeft} 12px`};
    @media only screen and (${Breakpoints.LAPTOP}) {
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        padding: ${({ theme }) => `13px ${theme.paddings.inner.tablet.paddingLeft}`};
    }
`;
export const FooterAppLinks = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    @media only screen and (${Breakpoints.LAPTOP}) {
        flex-flow: row nowrap;
    }
`;
export const FooterAppLinksItem = styled.a`
    width: 135px;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    border: ${({ theme }) => `1px solid ${theme.palette.white}`};
    border-radius: 6px;
    margin: 0 0 20px;
    @media only screen and (${Breakpoints.LAPTOP}) {
        margin: 0 10px 0;
        background: 'transparent';
    }
`;
export const FooterLinks = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    & > * {
        margin-bottom: 6px;
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        flex-flow: row nowrap;
        justify-content: space-between;
        text-align: left;
        & > * {
            margin-bottom: 0;
            margin-right: 40px;
        }
    }
`;
export const FooterLinkText = styled.div<{ uppercase?: boolean }>`
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 8px;
    & span {
      text-transform: ${({ uppercase }) => uppercase && 'uppercase'};
      font-size: 9px;
      line-height: 12px;
    }
`;
export const FooterCopyright = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.color.footer};
    @media only screen and (${Breakpoints.LAPTOP}) {
        text-align: right;
    }
`;
